<!--Header-->
<app-navbar>
    <h2>Despre AgribusinessJob</h2>
</app-navbar>
<!--Page info-->
<div class="portal-area pb-70">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col">
                <!--Title -->
                <h1>Despre AgribusinessJob </h1>
                <p>
                    Compania Agribusinessjob a fost fondată în 2010, de către Marius Ogrezeanu, fiind prima companie specializată de recrutare în sectorul agri-zoo-vet-food din România. 
                    <br><br>
                    Lansarea companiei în acest sector a venit ca o continuare a activităților antreprenoriale dezvoltate anterior de către fondator în sfera resurselor umane, răspunzând  astfel nevoilor angajatorilor din sectorul agricol.
                    <br><br>         
                        Având focus doar pe personal specializat, cu studii superioare, în cei 13 ani de activitate am dezvoltat servicii și produse inovative:
                        
                            <li>                 serviciile de recrutare personal adresate celor 3 niveluri de experiență: junior, specialist, top management, servicii care se transformă din 2023 în divizia Agribusinessjob STAFF </li>
                            <li>                 joburi și evenimente de carieră adresate candidaților juniori, lansate în 2014, desfășurate în universitățile de profil din România, care se transformă din 2023 în divizia Agribusinessjob JUNIOR. </li>
                        
                <br><br>
                Inițiatori ai serviciilor de recrutare în agricultura din România, lansăm, în premieră pe piața muncii, segmentul SPECIALIȘTILOR,
                agribusinessjob.com - Platformă de joburi dedicată sectorului agri-food din România,
                răspunzând astfel nevoilor de specializare și digitalizare din acest sector.
                <br><br>
                Astfel, prin dezvoltarea și integrarea celor 3 divizii (STAFF, SPECIALISTI și JUNIOR), compania Agribusinessjob intră într-o nouă etapă, continuând să inoveze acest sector strategic pentru siguranța alimentară a populației.
                </p>
            </div>
            <div class="col">
                <!-- Picture -->
                <img class="image-fluid" src="assets/img/about-us/about-us.jpg" alt="Portal">
            </div>
        </div>
    </div>
</div>
<!--Banner Jobs-->
<div class="counter-area pt-70 pb-70">
    <div class="container">
        <div class="row justify-content-center">
            <div class="text-center col-12 mt-20 mb-20">
                <!--Banner title-->
                <h2>AgribusinessJob</h2>
                <p>Munca noastră se vede și în cifre:</p>
            </div>
        </div>
        <!--Banner icons & counters-->
        <div class="row justify-content-center">
            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon-->
                    <i class="flaticon-employee"></i>
                    <!--counter-->
                    <h3><span class="counter">22</span></h3>
                    <!--info counter-->
                    <p>Candidați</p>
                    <p>&nbsp;&nbsp;Disponibili</p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon-->
                    <i class="flaticon-curriculum"></i>
                    <!--counter-->
                    <h3><span class="counter">03</span></h3>
                    <!--info counter-->
                    <p>Locuri de muncă </p>
                    <p>disponibile</p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon -->
                    <i class="flaticon-enterprise"></i>
                    <!--counter-->
                    <h3><span class="counter">22</span></h3>
                    <!--info counter-->
                    <p>Companii</p>
                    <p>Angajatoare</p>
                </div>
            </div>

            <!--single icon & counter-->
            <div class="col-md-3">
                <div class="counter-item">
                    <!--single icon -->
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <!--counter-->
                    <h3><span class="counter">12</span></h3>
                    <!--info counter-->
                    <p>ani de ABJ</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--pictures & info-->
<div class="info-area white-background">
    <div class="container-fluid overflow-hidden">
        <div class="row info-row pt-100 info-row-1">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7">
                    <h3>Agribusinessjob STAFF</h3>
                    <div class="empty-row-30"></div>
                    <p>- divizia de recrutare specializată în poziții strategice <br>
                        - servicii de consultanță în resurse umane<br>
                        - evaluare a profilului candidaților, angajaților, echipelor<br>
                        - compania Agribusinessjob este certificată PERSOLOG la nivel european
                        </p>
                    <div class="empty-row-30"></div>
                    <!-- <a href="#" class="simple-text-button d-flex align-items-center"><i class="icofont-play-alt-2"></i>
                        Vezi video</a> -->
                        <a routerLink="/agribusiness-staff" target="_blank">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 info-row-2">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7 offset-md-5">
                    <h3>Agribusinessjob – SPECIALIST</h3>
                    <div class="empty-row-30"></div>
                    <p>- divizia ce gestionează platforma de joburi specializată în sectorul agri-zoo-vet-food<br>
                        - ajută companiile să își desfășoare independent angajările de specialiști, prin postarea de joburi direct de către reprezentanții companiei dvs.
                        </p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/agribusiness-specialisti" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
        <div class="row info-row pt-100 pb-100 info-row-3">
            <div class="container">
                <!--block info-->
                <div class="info-block col-md-7">
                    <h3>Agribusinessjob - JUNIOR</h3>
                    <div class="empty-row-30"></div>
                    <p>- divizia care gestionează oportunitățile de carieră pentru studenți și proaspeți absolvenți, atât prin intermediul platformei de joburi, cât și prin evenimentele dedicate tinerilor specialiști, implementate la nivel național.<br>
                        - tinerii pot descoperi aici oportunități de practică, voluntariat, internship plătit, joburi în domeniul lor de activitate, dar și resurse importante privind consilierea în carieră.</p>
                    <div class="empty-row-30"></div>
                    <a routerLink="/agribusiness-juniori" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner Domains-->
<div class="counter-area pt-70 pb-70">
    <div class="container">
        <!--domains title & info-->
        <div class="row justify-content-center">
            <div class="text-center col-12 mt-20 mb-10">
                <h2> Domeniile AgribusinessJob</h2>
                <p>Facilităm proiecte sănătoase de recrutare și dezvoltare în carieră pentru Companii și Specialiști  </p>
                <p>încă din 2010.</p>
            </div>
        </div>
        <!--domains icons & counters-->
        <div class="row justify-content-center pb-20">
            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-employee"></i>
                    <!--info & counter-->
                    <h2>Agricultură</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>

                </div>
            </div>
            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-curriculum"></i>
                    <!--info & counter-->
                    <h2>Horticultură</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-enterprise"></i>
                    <!--info & counter-->
                    <h2>Apicultură</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <!--info & counter-->
                    <h2>Zootehnie</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>

            <!--domain single icon & counter -->
            <div class="col-md-2">
                <div class="counter-item">
                    <!--icon-->
                    <i class="flaticon-businessman-paper-of-the-application-for-a-job"></i>
                    <!--info & counter-->
                    <h2>Ind. Alimentară</h2>
                    <p>(34 {{'HOMEPAGE.JOB_SEARCH.AVAILABLE_JOBS' | translate}})</p>
                </div>
            </div>
        </div>
        <!--button more jobs-->
        <div class="text-center col-12 pb-10">
            <a class="green-button" routerLink="/joburi">VEZI TOATE JOBURILE</a>
        </div>

    </div>
</div>
<!--Bottom pictures-->
<div class="picture-area">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- left picture-->
                <div class="row">
                    <div class="col">
                        <!-- left picture info-->
                        <div class="pictureLeft">
                            <h2>Vrei să angajezi? Postează un job!</h2>
                            <a href="/pachete" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>

                        </div>
                    </div>
                    <!-- right picture-->
                    <div class="col">
                        <!-- right picture info-->
                        <div class="pictureRight">
                            <h2>Cauți un loc de muncă?</h2>
                            <!-- <h1>Află cum poți face următorul pas în carieră cu</h1>
                            <p>Agribusiness Job</p> -->
                            <a href="/joburi" class="simple-text-button">{{'HOMEPAGE.MORE_DETAILS' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
